"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _link = _interopRequireDefault(require("@clayui/link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["as", "active", "children", "disabled", "href"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayPaginationItem = function ClayPaginationItem(_ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? _link.default : _ref$as,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      href = _ref.href,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)('page-item', {
      active: active,
      disabled: disabled
    })
  }, As === 'div' ? /*#__PURE__*/_react.default.createElement(As, _extends({}, otherProps, {
    className: "page-link"
  }), children) : /*#__PURE__*/_react.default.createElement(As, _extends({}, otherProps, {
    "aria-current": active && href ? 'page' : undefined,
    className: "page-link",
    href: disabled || active ? undefined : href,
    onClick: function onClick(event) {
      if (!href) {
        event.preventDefault();
      }

      if (otherProps.onClick) {
        otherProps.onClick(event);
      }
    },
    tabIndex: active || !href && !disabled ? 0 : undefined
  }), children));
};

var _default = ClayPaginationItem;
exports.default = _default;